module.exports = __webpack_public_path__ + "img/pushgaming.71367e0b.svg";